import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { RoundedSpinnerIcon } from '@/components/Common'

export const Button = ({ text, type, className, isDisabled, isLoading, children, onClick, ...rest }) => {
  const buttonClasses = classNames('py-2 px-5 bg-[#adc178] text-white rounded-lg', className, {
    'transition ease-in-out duration-300 delay-50 hover:opacity-80': !isDisabled,
    'opacity-40 cursor-not-allowed': isDisabled,
    'flex gap-2 items-center': isLoading,
  })
  return (
    <button type={type} className={buttonClasses} onClick={onClick} disabled={isDisabled} {...rest}>
      {text !== '' ? text : children}
      {isLoading && <RoundedSpinnerIcon stroke='#fff' />}
    </button>
  )
}

Button.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit']),
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
}

Button.defaultProps = {
  text: '',
  type: 'button',
  isLoading: false,
  isDisabled: false,
  onClick: () => {},
}
